module.exports = __webpack_public_path__ + "media/newstyle/images/icon-print-0b3747e6176901d749ccb3f3eafd6ab8.svg";